import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"

import * as S from "./banner-slider.styles"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import CustomArrows from "../../components/custom-arrows/custom-arrows.component"

const BannerSlider = ({ title, backgroundImage, testimonialsSlider }) => {
  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <S.BgImage img={backgroundImage}>
          <S.ContentContainer maxWidth="xl">
            <S.Title>{title}</S.Title>
            <S.SliderContainer>
              <Swiper
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".prevInfoSlider",
                  nextEl: ".nextInfoSlider",
                }}
              >
                {testimonialsSlider?.map(
                  ({ name, testimonialDescription, logo }, index) => (
                    <SwiperSlide key={`slide-${index}`}>
                      <S.InfoContainer>
                        <S.Logo img={logo} />
                        <S.Testimonial>{testimonialDescription}</S.Testimonial>
                        <S.Name>{name}</S.Name>
                      </S.InfoContainer>
                    </SwiperSlide>
                  ),
                )}
              </Swiper>

              <CustomArrows
                leftArrow="prevInfoSlider"
                rightArrow="nextInfoSlider"
              />
            </S.SliderContainer>
          </S.ContentContainer>
        </S.BgImage>
      </S.Wrapper>
    </S.Section>
  )
}

export default BannerSlider
